// extracted by mini-css-extract-plugin
module.exports = {"box":"box--1zcLI","article":"article--uOeKI","title":"title--35pQ2","date":"date--1AVTb","content":"content--1qFnE"};